import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

export const [Currencies, CurrencySchema, Currency] = EnumBuilder('USD')

export type Currency = ZodInfer<typeof CurrencySchema>

export function isCurrency(value: string): value is Currency {
  return CurrencySchema.safeParse(value).success
}
